export default "__VITE_ASSET__CQw6U59L__"